<dialog
  #actionDialog
  qai-dialog
  [heading]="
    'simulationBuilder.MODAL_TITLE'
      | transloco: {
          action: (entityActionType() === EntityActionType.DUPLICATE ? 'simulationBuilder.ACTION_DUPLICATE' : 'simulationBuilder.ACTION_CREATE_NEW') | transloco,
          type: (entityType() === EntityType.SIMULATION ? 'simulationBuilder.ENTITY_TYPE_SIMULATION_DISPLAY' : 'simulationBuilder.ENTITY_TYPE_ASSIGNMENT_DISPLAY') | transloco
        }
  "
  (closeButtonClicked)="handleCloseClick()"
>
  <div class="modal-body">
    <qai-field
      [label]="
        (entityType() === 'assignment' ? 'simulationBuilder.ASSIGNMENT_NAME_LABEL' : 'simulationBuilder.SIMULATION_NAME_LABEL') | transloco
      "
      [description]="'simulationBuilder.NAME_FIELD_DESCRIPTION' | transloco"
      [error]="errorMessage"
    >
      <input
        qai-input
        type="text"
        [(ngModel)]="inputName"
        (input)="onInputChange()"
      />
    </qai-field>

    @if (entityType() === EntityType.SIMULATION) {
      <qai-field
        [label]="'simulationBuilder.PRODUCT_LABEL' | transloco"
        class="product-field"
      >
        <qai-floating-select
          [options]="moduleOptions"
          [placeholder]="'simulationBuilder.SELECT_A_PRODUCT_PLACEHOLDER' | transloco"
          [placement]="'below-start'"
          [offset]="4"
          [shape]="'rectangle'"
          [value]="selectedModuleUuid"
          [searchable]="true"
          [showActionButton]="true"
          [actionButtonLabel]="'simulationBuilder.ADD_NEW_PRODUCT' | transloco"
          [disabled]="networkRequestInProgress() || isLoadingModuleOptions"
          (action)="onAddNewProduct($event)"
          (selectionChange)="onModuleSelectionChange($event?.value)"
        ></qai-floating-select>
      </qai-field>
    }
  </div>

  <div class="action-button-container">
    <button
      qai-button
      size="medium"
      kind="primary"
      [disabled]="isConfirmDisabled()"
      (click)="handleConfirmClick()"
    >
      {{ confirmButtonLabel() }}
    </button>
  </div>
</dialog>

<leave-confirmation-modal
  [open]="showLeaveConfirmation"
  (openChange)="showLeaveConfirmation = $event"
  [networkRequestInProgress]="isLeaving"
  (confirm)="onLeaveConfirmed()"
  (closeModal)="onLeaveCancelled()"
></leave-confirmation-modal>
